import React,{useMemo} from 'react';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry, themeAlpine } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

export default function MetricusDataGrid({
  rowData=[],
  columnDefs=[],
  height=380,
  emptyMessage='No data to display',
  className='',
  ...props
}){
  const defaultColDef=useMemo(()=>({
    sortable:true,
    resizable:true,
    suppressHeaderMenuButton:true,
    minWidth:90,
  }),[]);

  return <div className={`metricus-data-grid ${className}`.trim()} style={{height}}>
    <AgGridReact
      theme={themeAlpine}
      rowData={rowData}
      columnDefs={columnDefs}
      defaultColDef={defaultColDef}
      headerHeight={40}
      rowHeight={44}
      animateRows={false}
      suppressCellFocus
      overlayNoRowsTemplate={`<span class="metricus-grid-empty">${emptyMessage}</span>`}
      {...props}
    />
  </div>;
}
